import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconGradientColored = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsxs(Fragment, { children: [jsx("path", { d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4Z", fill: "url(#icon-gradient-colored-1)" }), jsx("defs", { children: jsxs("linearGradient", { id: "icon-gradient-colored-1", x1: "2", y1: "12.0013", x2: "22", y2: "12.0013", gradientUnits: "userSpaceOnUse", children: [jsx("stop", { stopColor: "#FF0000" }), jsx("stop", { offset: "0.33", stopColor: "#FEE600" }), jsx("stop", { offset: "0.66", stopColor: "#00FFFF" }), jsx("stop", { offset: "0.995", stopColor: "#9E00FF" })] }) })] }),
});

export { IconGradientColored };
